import React from 'react';
import DisplayField from '../../../../../itrust_common/components/others/DisplayField'
import OldValuesHeader from '../../oldValues/OldValuesHeader';

let PupillaryDistance = props => {
  const { previousExams, overviewName, examId, fieldsValues } = props;

  const renderTable = (fieldsValues) => (
    <div className="col-12">
      <div className="overview-table mb-3">
        <table className="table table-bordered bg-light table-hover shadow-none border border-muted">
          <thead className="text-dark border border-muted">
            <tr className="text-center">
              <th scope="col"></th>
              <th scope="col"><DisplayField isVisible={true} label={"Distance"} /></th>
              <th scope="col"><DisplayField isVisible={true} label={"Intermediate"} /></th>
              <th scope="col"><DisplayField isVisible={true} label={"Near"} /></th>
            </tr>
          </thead>
          <tbody>
            {["od", "os", "ou"].map(type =>
              <tr className="text-center">
                <td><h6>{type.toUpperCase()}</h6></td>
                <td><DisplayField isVisible={true} value={fieldsValues?.[`${type}_distance`]} /></td>
                <td><DisplayField isVisible={true} value={fieldsValues?.[`${type}_intermediate`]} /></td>
                <td><DisplayField isVisible={true} value={fieldsValues?.[`${type}_near`]} /></td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  )

  return (
    <>
      {fieldsValues && renderTable(fieldsValues)}
      {previousExams?.filter(item => item.id !== examId).map(prevExam =>
        <div className="col-12 border rounded mb-4 px-0">
          <div className="row mx-0">
            <OldValuesHeader prevExam={prevExam} overviewName={overviewName} examId={examId} />
            {renderTable(prevExam?.pupillary_distance)}
          </div>
        </div>
      )}
    </>
  )
}


export default PupillaryDistance;